import type { FormItemProps } from 'antd';

import { isExist } from '@util/data/is-exist';

import { LabelStyled, LabelText } from './label.style';

export const Label = (props: FormItemProps) => (
  <LabelStyled {...props} label={isExist(props.label) ? <LabelText>{props.label}</LabelText> : null} />
);
